// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3k0An","content":"LayoutSettings_content__2FlCO"};